$(document).ready(function() {
   $(".globo-formbuilder").animate({opacity:1},200);



 // Get all swatch labels
$(".product-card__info label[data-color-name]").on("click", function () {
  const $label = $(this);

  // Find the nearest .product-card__info and the .swatch_name inside it
  const $productCard = $label.closest(".product-card__info");
  const $swatchNameDiv = $productCard.find(".swatch_name");

  // Add the "hide" class immediately on click
  if ($swatchNameDiv.length) {
    $swatchNameDiv.addClass("hide_0");
  }

  // Delay before updating the swatch name and showing it again
  setTimeout(function () {
    const selectedColor = $label.data("color-name");

    if ($swatchNameDiv.length) {
      $swatchNameDiv.text(selectedColor);
     // $swatchNameDiv.removeClass("hide"); // Remove the hide class after update
    }

    // Toggle active class within this product card
    const $allLabels = $productCard.find("label[data-color-name]");
    $allLabels.removeClass("active");
    $label.addClass("active");
  }, 100); // Delay in milliseconds
});


// cart drawer gift note textarea focus
  $('.cart-drawer__footer-action-button').on('click', function () {
      setTimeout(function() {
       
    $('#cart-drawer cart-note textarea').focus();
     }, 300);
  });




  
});



// Keep the cart drawer open while the BlackCrow-triggered Klaviyo signup popup
// is on top of it. The drawer is a focus-trapped dialog, so without this any
// click inside the popup (or Escape) counts as an outside click and closes the
// drawer, and the trap steals focus from the popup's email input. Pausing the
// trap while a Klaviyo form is open fixes all three.
(function () {
  var klaviyoFormOpen = false;

  function syncCartDrawerTrap() {
    // setTimeout: dialog:after-show fires just before the trap activates,
    // and pause() is a no-op on an inactive trap
    setTimeout(function () {
      var drawer = document.getElementById('cart-drawer');
      if (!drawer || !drawer.open || !drawer.focusTrap) return;
      if (klaviyoFormOpen) {
        drawer.focusTrap.pause();
        // the drawer's shadow base is fixed at z-index 999999, above Klaviyo's
        // inline 90000, so the popup renders underneath it - raise the popup
        document.querySelectorAll('div[class*="kl-private-reset-css"]').forEach(function (el) {
          if (getComputedStyle(el).position === 'fixed') el.style.zIndex = '1000000';
        });
      } else {
        drawer.focusTrap.unpause();
      }
    }, 0);
  }

  window.addEventListener('klaviyoForms', function (e) {
    var type = e.detail && e.detail.type;
    if (type === 'open') {
      klaviyoFormOpen = true;
      syncCartDrawerTrap();
    } else if (type === 'close') {
      klaviyoFormOpen = false;
      syncCartDrawerTrap();
    }
  });

  // popup and drawer both trigger on add-to-cart; if the popup opens first,
  // re-sync once the drawer finishes opening
  document.addEventListener('dialog:after-show', function (e) {
    if (e.target && e.target.id === 'cart-drawer' && klaviyoFormOpen) syncCartDrawerTrap();
  }, true);

  // clicks on Klaviyo UI (form or teaser tab) must never count as an
  // outside click that closes the drawer
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var origHide = drawer.hideForOutsideClickTarget
      ? drawer.hideForOutsideClickTarget.bind(drawer)
      : null;
    drawer.hideForOutsideClickTarget = function (target) {
      if (target && target.closest && target.closest('[class*="kl-private-reset-css"]')) return false;
      return origHide ? origHide(target) : !drawer.contains(target);
    };
  });
})();
